module.exports = __webpack_public_path__ + "images/new-gap-waiver-car.529bdfda54633e28a7a554e4d9be6291.png";